import axios from 'axios'

export const fetchPlaces = async (state, city) => {
  const baseURL = window.location.origin
  const { data } = await axios.get(
    `${baseURL}/api/v1/dealer/store/list_by_city?stateId=${state}&city=${city}`
  )
  return data
}
